// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d1cf2439","562":"be4943bd","564":"89d0f684"}[chunkId] + ".chunk.js";
};